<template>
    <div id="bene-home-phone-popover-container">
        <f7-popover id="beneHomeNoDropdown" class="popover-home-no mobile-country-code beneficiary" :backdrop="true">
            <f7-searchbar id="beneHomeCountryCodeSearch" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch"></f7-searchbar>
              <f7-list class="searchbar-not-found">
                <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
              </f7-list>
              <f7-list class="country-code-list">
                <f7-list-item popover-close link="#" v-for="hIDD in countryCodeList" :key="hIDD.id" @click="changeHomePhoneCode(hIDD.id)">
                    <img :src="getFlagImg(hIDD.id)" class="mr-sm" loading="lazy"/>
                    <span class="country-name">{{hIDD.name+" "+hIDD.idd}}</span>
                </f7-list-item>
            </f7-list>
        </f7-popover>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init()
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'countryCodeList',
            ]),
            ...mapGetters('misc', [
                'latestCountryCodePopoverDirection',
              ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setHomeNo',
                'changeHomePhoneCode',
                'validateInput'
            ]),

            init() {
                const self    = this;
                const popover = ".beneficiary.popover-home-no";
                const popoverInner = ".beneficiary.popover-home-no .popover-inner";
                const popoverId = "beneHomeNoDropdown";
                const inputId = "homeNo";
                const inputListId = "#homeNoListId";

                self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "beneHomeCountryCode", "beneHomeCountryCodeSearch")
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            },

            onSearch(){
                const self    = this;
                if(self.latestCountryCodePopoverDirection == "above"){
                    const popover = ".beneficiary.popover-home-no";
                    const popoverInner = ".beneficiary.popover-home-no .popover-inner";
                    const popoverId = "beneHomeNoDropdown";
                    const inputId = "homeNo";
                    const inputListId = "#homeNoListId";

                    self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "beneHomeCountryCode", "beneHomeCountryCodeSearch", true)                    
                }
            }
        }
    }
</script>